export default {
  // 標題
  title: "交易數量配置",

  // 複選框
  includeZero: "包含0",

  // 錯誤提示
  maxValueError: "最大值需大於最小值",

  // 按鈕
  reset: "重置",
  confirm: "確定",

  // 成功消息
  saveSuccess: "保存成功",
};
